// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteInvoice_root__1yfUe"};